import styled from '@emotion/styled';
import { Stack } from '@mui/material';
import { dateToStr, labelName, useItemNames, useLocalizedContents } from '@ps-smart-cp/ppfw-client';
import { useProcessingMonth } from '../context';

const ProcessingMonthContainer = styled.div`
  display: inline-block;
  width: 60px;
  height: 24px;
  margin-top: 7px;
  line-height: 24px;
  text-align: center;
  border: 1px solid #666;
  background: linear-gradient(to bottom, #616170 0%, #50505f 30%, #343443 100%);
`;

const ProcessingMonthName = styled(ProcessingMonthContainer)`
  border-radius: 8px 0px 0px 8px;
`;

const ProcessingMonth = styled(ProcessingMonthContainer)`
  width: 70px;
  font-weight: bold;
  border-left: 0px;
  border-radius: 0px 8px 8px 0px;
`;

function ProcessingMonthLabel() {
  const getLabelName = useItemNames(labelName);
  const { processingMonth } = useProcessingMonth();
  const { dateFormat } = useLocalizedContents();

  return (
    <Stack id="global-processing-month-label" justifyContent="flex-start" direction="row">
      <ProcessingMonthName>{getLabelName('processingMonth')}</ProcessingMonthName>
      <ProcessingMonth>{dateToStr(processingMonth, dateFormat.ym)}</ProcessingMonth>
    </Stack>
  );
}

export { ProcessingMonthLabel };
